import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSection = ({ currentLanguage }) => {
  const contactInfo = {
    phone: '+254 721 320 787',
    whatsapp: '+254721320787',
    email: 'info@peterpartnerslaw.co.ke'
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I would like to inquire about your legal services.' :'Hujambo, ningependa kuuliza kuhusu huduma zenu za kisheria.');
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.open(`tel:${contactInfo.phone}`, '_self');
  };

  return (
    <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg p-8 mt-12">
      <div className="text-center max-w-2xl mx-auto">
        <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-full mx-auto mb-6">
          <Icon name="Scale" size={32} color="white" strokeWidth={2} />
        </div>
        
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-text-primary mb-4">
          {currentLanguage === 'en' ?'Ready to Get Legal Assistance?' :'Uko Tayari Kupata Msaada wa Kisheria?'}
        </h2>
        
        <p className="text-text-secondary mb-8 leading-relaxed">
          {currentLanguage === 'en' ?'Our experienced legal team is here to help you navigate complex legal matters. Contact us today for a consultation tailored to your specific needs.' :'Timu yetu ya wakili wenye uzoefu iko hapa kukusaidia kupitia mambo magumu ya kisheria. Wasiliana nasi leo kwa mazungumzo yaliyoandaliwa kwa mahitaji yako maalum.'}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            variant="primary"
            size="lg"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={handleWhatsAppClick}
            className="min-w-[200px]"
          >
            {currentLanguage === 'en' ? 'WhatsApp Consultation' : 'Mazungumzo ya WhatsApp'}
          </Button>
          
          <Button
            variant="outline"
            size="lg"
            iconName="Phone"
            iconPosition="left"
            onClick={handleCallClick}
            className="min-w-[200px]"
          >
            {currentLanguage === 'en' ? 'Call Now' : 'Piga Simu Sasa'}
          </Button>
        </div>

        <div className="mt-6 flex items-center justify-center space-x-6 text-sm text-text-secondary">
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={16} />
            <span>{currentLanguage === 'en' ? '24/7 Available' : 'Inapatikana 24/7'}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} />
            <span>{currentLanguage === 'en' ? 'Confidential' : 'Siri'}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Award" size={16} />
            <span>{currentLanguage === 'en' ? 'Expert Advice' : 'Ushauri wa Kitaalamu'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;